import { ReactNode } from "react";
import "./FormLayout.scss";

const FormLayout = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <>
      <div className="form-layout-bg" />
      <div className={`form-layout ${className ?? ""}`}>{children}</div>
    </>
  );
};

export default FormLayout;
